import CrudService from 'services/cruds-service'
import React from 'react'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { FormControl, Grid, IconButton, InputLabel, MenuItem, Select, TextField, Tooltip } from '@mui/material'
import MDInput from 'components/MDInput'
import MDButton from 'components/MDButton'
import DeleteIcon from '@mui/icons-material/Delete';
import DataTable from 'examples/Tables/DataTable'

const ServiceRequestLinesForm = React.memo(
    ({
        updateRequestLines,
        lines = [],
        service_request_id
    }) => {

        const [serviceTypes, setServiceTypes] = React.useState([])
        const [statusList, setStatusList] = React.useState([])
        const [contactList, setContactList] = React.useState([])
        const [userList, setUserList] = React.useState([])
        const [serviceRequestLines, setServiceRequestLines] = React.useState(lines ?? []);

        async function fetchUtils() {
            let resp = await CrudService.getServiceLineUtils();

            if (resp.success) {
                const { service_request_types, status_types, contact, user } = resp.data
                setServiceTypes(service_request_types);
                setStatusList(status_types);
                setContactList(contact)
                setUserList(user)
            }

        }

        React.useEffect(() => {
            fetchUtils();
        }, [])

        React.useEffect(() => {
            updateRequestLines(serviceRequestLines)
        }, [serviceRequestLines])

        function onChange(index, target) {
            const deepCopyPayload = JSON.parse(JSON.stringify(serviceRequestLines))
            const key = target['name']
            deepCopyPayload[index][key] = target['value']
            setServiceRequestLines(deepCopyPayload)
        }

        function AddNewItem() {
            const payload = {
                "service_request_id": service_request_id,
                "service_request_type_id": null,
                "status_type_id": 1,
                "assigned_to_contact_id": null,
                "completed_by_user_id": null,
                "map_identifier": "",
                "location_description": "",
                "service_latitude": "",
                "service_longitude": "",
                "requested_date": null,
                "scheduled_date": null,
                "completed_date": null,
                "description": "",
                "external_reference_id": "",
                "quantity": 0,
                "price": "",
            }
            setServiceRequestLines((prev) => [...prev, payload])
        }

        function removeItem(index) {
            let deepCopyData = JSON.parse(JSON.stringify(serviceRequestLines))
            deepCopyData.splice(index, 1)
            setServiceRequestLines(deepCopyData)
        }

        const getRows = () => {
            return serviceRequestLines.map((value, index) => {
                const fields = [];

                fields.push(
                    {
                        service_request_type_id: (
                            <FormControl variant="standard" fullWidth>
                                {/* <InputLabel id={`${index}_service_request_type`}>Service Request Type</InputLabel> */}
                                <Select
                                    // labelId={`${index}_service_request_type`}
                                    id={`${index}_type`}
                                    value={value.service_request_type_id}
                                    label="Service Request Type"
                                    name="service_request_type_id"
                                    onChange={(e) => onChange(index, e.target)}
                                    sx={{
                                        '& .MuiSelect-select': {
                                            minHeight: '3em !important'
                                        }
                                    }}
                                >
                                    {
                                        serviceTypes && serviceTypes.map((e) => (
                                            <MenuItem value={e.service_request_type_id}>{e.type_name}</MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                        ),
                        status_type_id: (
                            <FormControl  variant="standard" fullWidth>
                                {/* <InputLabel id={`${index}_status_type_id`}>Status</InputLabel> */}
                                <Select
                                    // labelId={`${index}_status_type_id`}
                                    id={`${index}_status`}
                                    value={value.status_type_id}
                                    label="Status"
                                    name="status_type_id"
                                    onChange={(e) => onChange(index, e.target)}
                                    sx={{
                                        '& .MuiSelect-select': {
                                            minHeight: '3em !important'
                                        }
                                    }}
                                >
                                    {
                                        statusList && statusList.map((e) => (
                                            <MenuItem value={e.status_type_id}>{e.status_name}</MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                        ),
                        assigned_to_contact_id: (
                            <FormControl variant="standard" fullWidth>
                                {/* <InputLabel id={`${index}_assigned_to_contact_id`}>Assigned Contact</InputLabel> */}
                                <Select
                                    // labelId={`${index}_assigned_to_contact_id`}
                                    id={`${index}_assigned_contact`}
                                    value={value.assigned_to_contact_id}
                                    label="Assigned Contact"
                                    name="assigned_to_contact_id"
                                    onChange={(e) => onChange(index, e.target)}
                                    sx={{
                                        '& .MuiSelect-select': {
                                            minHeight: '3em !important'
                                        }
                                    }}
                                >
                                    {
                                        contactList && contactList.map((e) => (
                                            <MenuItem value={e.contact_id}>{e.first_name + ' ' + e.last_name}</MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                        ),
                        completed_by_user_id: (
                            <FormControl variant="standard" fullWidth>
                                {/* <InputLabel id={`${index}_completed_by_user_id`}>Completed Contact</InputLabel> */}
                                <Select
                                    // labelId={`${index}_completed_by_user_id`}
                                    id={`${index}_completed_contact`}
                                    value={value.completed_by_user_id}
                                    label="Completed Contact"
                                    name="completed_by_user_id"
                                    onChange={(e) => onChange(index, e.target)}
                                    sx={{
                                        '& .MuiSelect-select': {
                                            minHeight: '3em !important'
                                        }
                                    }}
                                >
                                    {
                                        userList && userList.map((e) => (
                                            <MenuItem value={e.id}>{e.name}</MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                        ),
                        map_identifier: (
                            <MDInput
                                fullWidth
                                variant="standard"
                                type="text"
                                // label="Map Identifier"
                                name="map_identifier"
                                value={value.map_identifier}
                                onChange={(e) => onChange(index, e.target)}
                            />
                        ),
                        location_description: (
                            <MDInput
                                fullWidth
                                variant="standard"
                                type="text"
                                // label="Location description"
                                name="location_description"
                                value={value.location_description}
                                onChange={(e) => onChange(index, e.target)}
                            />
                        ),
                        description: (
                            <MDInput
                                fullWidth
                                variant="standard"
                                type="text"
                                // label="Description"
                                name="description"
                                value={value.description}
                                onChange={(e) => onChange(index, e.target)}
                            />
                        ),
                        external_reference_id: (
                            <MDInput
                                fullWidth
                                variant="standard"
                                type="text"
                                // label="External Reference Id"
                                name="external_reference_id"
                                value={value.external_reference_id}
                                onChange={(e) => onChange(index, e.target)}
                            />
                        ),
                        service_latitude: (
                            <MDInput
                                fullWidth
                                variant="standard"
                                type="text"
                                // label="Service Latitude"
                                name="service_latitude"
                                value={value.service_latitude}
                                onChange={(e) => onChange(index, e.target)}
                            />
                        ),
                        service_longitude: (
                            <MDInput
                                fullWidth
                                variant="standard"
                                type="text"
                                // label="Service Longitude"
                                name="service_longitude"
                                value={value.service_longitude}
                                onChange={(e) => onChange(index, e.target)}
                            />
                        ),
                        quantity: (
                            <MDInput
                                fullWidth
                                variant="standard"
                                type="number"
                                // label="Quantity"
                                name="quantity"
                                value={value.quantity}
                                onChange={(e) => onChange(index, e.target)}
                            />
                        ),
                        price: (
                            <MDInput
                                fullWidth
                                variant="standard"
                                type="text"
                                // label="Price"
                                name="price"
                                value={value.price}
                                onChange={(e) => onChange(index, e.target)}
                            />
                        ),
                        requested_date: (
                            <TextField
                                fullWidth
                                variant="standard"
                                // label="Requested date"
                                name="requested_date"
                                type="date"
                                defaultValue={value?.requested_date}
                                InputLabelProps={{ shrink: true }}
                                // inputProps={{ min: today }}
                                value={value.requested_date}
                                onChange={(event) => onChange(index, event.target)}
                            />
                        ),
                        scheduled_date: (
                            <TextField
                                fullWidth
                                variant="standard"
                                // label="Scheduled date"
                                name="scheduled_date"
                                type="date"
                                defaultValue={value?.scheduled_date}
                                InputLabelProps={{ shrink: true }}
                                // inputProps={{ min: today }}
                                value={value.scheduled_date}
                                onChange={(event) => onChange(index, event.target)}
                            />
                        ),
                        completed_date: (
                            <TextField
                                fullWidth
                                variant="standard"
                                // label="Completed date"
                                name="completed_date"
                                type="date"
                                defaultValue={value?.completed_date}
                                InputLabelProps={{ shrink: true }}
                                // inputProps={{ min: today }}
                                value={value.completed_date}
                                onChange={(event) => onChange(index, event.target)}
                            />
                        ),
                    }
                );

                return Object.assign({}, ...fields);
            });
        };

        const tableThresholdData = {
            columns: [
                { Header: "Type", accessor: "service_request_type_id" },
                { Header: "Status", accessor: "status_type_id" },
                { Header: "Assigned Contact", accessor: "assigned_to_contact_id" },
                { Header: "Completed Contact", accessor: "completed_by_user_id" },
                { Header: "Map ID", accessor: "map_identifier" },
                { Header: "Location", accessor: "location_description" },
                { Header: "Description", accessor: "description" },
                { Header: "Ext Ref ID", accessor: "external_reference_id" },
                { Header: "Lat", accessor: "service_latitude" },
                { Header: "Long", accessor: "service_longitude" },
                { Header: "Qty", accessor: "quantity" },
                { Header: "Price", accessor: "price" },
                { Header: "Requested", accessor: "requested_date" },
                { Header: "Scheduled", accessor: "scheduled_date" },
                { Header: "Completed", accessor: "completed_date" },
                {
                    Header: "Actions",
                    disableSortBy: true,
                    accessor: "",
                    Cell: (info) => {
                        return (
                            <MDBox display="flex" alignItems="center">
                                {(
                                    <Tooltip title="Remove Line">
                                        <IconButton onClick={() => removeItem(info.cell.row.index)}>
                                            <MDTypography><DeleteIcon /></MDTypography>
                                        </IconButton>
                                    </Tooltip>
                                )}
                            </MDBox>
                        );
                    },
                }
            ],
            rows: getRows(),
        };

        return <MDBox mt={1} mb={1}>
            <MDBox style={{ display: 'flex', alignItems: 'cemter', gap: '1rem' }}>
                <MDTypography>Service Request Lines</MDTypography>
                <MDButton onClick={AddNewItem} >Add</MDButton>
            </MDBox>
            <MDBox style={{ width: '100%' }}>
                <DataTable table={tableThresholdData} canSearch={false} tableHeight="calc(100vh - 410px)" />
            </MDBox>
        </MDBox>
    })

export default ServiceRequestLinesForm;